import { createReducer, on } from '@ngrx/store';
import { setMenuList } from './menu.actions';

export interface MenuState {
  menuList: any[];
}

export const initialState: MenuState = {
  menuList: [],
};

export const menuReducer = createReducer(
  initialState,
  on(setMenuList, (state, { menuList }) => ({ ...state, menuList })),
);
